import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = ["title", "aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconEmoticonOutline = _resolveComponent("IconEmoticonOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconArrowLeftTop = _resolveComponent("IconArrowLeftTop")
  const _component_IconCheckAll = _resolveComponent("IconCheckAll")
  const _component_IconCheck = _resolveComponent("IconCheck")
  const _component_IconClockOutline = _resolveComponent("IconClockOutline")
  const _component_NcActionText = _resolveComponent("NcActionText")
  const _component_IconClockEditOutline = _resolveComponent("IconClockEditOutline")
  const _component_IconBellOffOutline = _resolveComponent("IconBellOffOutline")
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")
  const _component_IconAlarm = _resolveComponent("IconAlarm")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconAccountOutline = _resolveComponent("IconAccountOutline")
  const _component_IconPencilOutline = _resolveComponent("IconPencilOutline")
  const _component_IconContentCopy = _resolveComponent("IconContentCopy")
  const _component_IconOpenInNew = _resolveComponent("IconOpenInNew")
  const _component_IconEyeOffOutline = _resolveComponent("IconEyeOffOutline")
  const _component_IconFileOutline = _resolveComponent("IconFileOutline")
  const _component_NcActionLink = _resolveComponent("NcActionLink")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_IconForumOutline = _resolveComponent("IconForumOutline")
  const _component_IconNoteEditOutline = _resolveComponent("IconNoteEditOutline")
  const _component_IconArrowRightTop = _resolveComponent("IconArrowRightTop")
  const _component_IconTranslate = _resolveComponent("IconTranslate")
  const _component_IconTrashCanOutline = _resolveComponent("IconTrashCanOutline")
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")
  const _component_IconCloseCircleOutline = _resolveComponent("IconCloseCircleOutline")
  const _component_IconCalendarClockOutline = _resolveComponent("IconCalendarClockOutline")
  const _component_NcActionInput = _resolveComponent("NcActionInput")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_NcEmojiPicker = _resolveComponent("NcEmojiPicker")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (!$props.isReactionsMenuOpen)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($props.canReact)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 0,
                variant: "tertiary",
                "aria-label": $options.t('spreed', 'Add a reaction to this message'),
                title: $options.t('spreed', 'Add a reaction to this message'),
                onClick: $options.openReactionsMenu
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconEmoticonOutline, { size: 20 })
                ]),
                _: 1
              }, 8, ["aria-label", "title", "onClick"]))
            : _createCommentVNode("", true),
          ($options.canReply)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 1,
                variant: "tertiary",
                "aria-label": $options.t('spreed', 'Reply'),
                title: $options.t('spreed', 'Reply'),
                onClick: $options.handleReply
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconArrowLeftTop, {
                    class: "bidirectional-icon",
                    size: 20
                  })
                ]),
                _: 1
              }, 8, ["aria-label", "title", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NcActions, {
            "force-menu": true,
            placement: "bottom-end",
            "boundaries-element": $options.boundariesElement,
            onOpen: $options.onMenuOpen,
            onClose: $options.onMenuClose
          }, {
            default: _withCtx(() => [
              ($data.submenu === null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_NcActionText, null, {
                      icon: _withCtx(() => [
                        ($props.readInfo.showCommonReadIcon)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: $props.readInfo.commonReadIconTitle,
                              "aria-label": $props.readInfo.commonReadIconTitle
                            }, [
                              _createVNode(_component_IconCheckAll, { size: 16 })
                            ], 8, _hoisted_1))
                          : ($props.readInfo.showSentIcon)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                title: $props.readInfo.sentIconTitle,
                                "aria-label": $props.readInfo.sentIconTitle
                              }, [
                                _createVNode(_component_IconCheck, { size: 16 })
                              ], 8, _hoisted_2))
                            : (_openBlock(), _createBlock(_component_IconClockOutline, {
                                key: 2,
                                size: 20
                              }))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.messageDateTime), 1)
                      ]),
                      _: 1
                    }),
                    ($props.message.lastEditTimestamp)
                      ? (_openBlock(), _createBlock(_component_NcActionText, {
                          key: 0,
                          class: "edit-timestamp",
                          name: $options.lastEditActorLabel
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconClockEditOutline, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.editedDateTime), 1)
                          ]),
                          _: 1
                        }, 8, ["name"]))
                      : _createCommentVNode("", true),
                    ($props.readInfo.showSilentIcon)
                      ? (_openBlock(), _createBlock(_component_NcActionText, { key: 1 }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconBellOffOutline, { size: 16 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($props.readInfo.silentIconTitle), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcActionSeparator),
                    ($setup.supportReminders)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "set-reminder-menu",
                          "is-menu": "",
                          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.submenu = 'reminder'), ["stop"]))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconAlarm, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Set reminder')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($options.isPrivateReplyable)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "reply-privately",
                          "close-after-click": "",
                          onClick: _withModifiers($options.handlePrivateReply, ["stop"])
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconAccountOutline, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Reply privately')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    ($setup.isEditable)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "edit-message",
                          "aria-label": $options.t('spreed', 'Edit message'),
                          "close-after-click": "",
                          onClick: _withModifiers($options.editMessage, ["stop"])
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconPencilOutline, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Edit message')), 1)
                          ]),
                          _: 1
                        }, 8, ["aria-label", "onClick"]))
                      : _createCommentVNode("", true),
                    (!$setup.isFileShareWithoutCaption)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "copy-message",
                          "close-after-click": "",
                          onClick: _withModifiers($options.handleCopyMessageText, ["stop"])
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconContentCopy, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy message')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcActionButton, {
                      key: "copy-message-link",
                      "close-after-click": "",
                      onClick: _withModifiers($options.handleCopyMessageLink, ["stop"])
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconOpenInNew, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy message link')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_NcActionButton, {
                      key: "mark-as-unread",
                      "close-after-click": "",
                      onClick: _withModifiers($options.handleMarkAsUnread, ["stop"])
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconEyeOffOutline, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Mark as unread')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    ($setup.isFileShare)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createVNode(_component_NcActionSeparator),
                          _createVNode(_component_NcActionLink, {
                            href: $options.messageFile.link
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconFileOutline, { size: 20 })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Go to file')), 1)
                            ]),
                            _: 1
                          }, 8, ["href"]),
                          (!$setup.hideDownloadOption)
                            ? (_openBlock(), _createBlock(_component_NcActionLink, {
                                key: 0,
                                href: $options.linkToFileDownload,
                                download: $options.messageFile.name,
                                "close-after-click": ""
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_NcIconSvgWrapper, {
                                    svg: $setup.IconFileDownload,
                                    size: 20
                                  }, null, 8, ["svg"])
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Download file')), 1)
                                ]),
                                _: 1
                              }, 8, ["href", "download"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    ($options.isThreadStarterMessage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                          _createVNode(_component_NcActionSeparator),
                          _createVNode(_component_NcActionButton, {
                            "close-after-click": "",
                            onClick: _cache[1] || (_cache[1] = $event => ($setup.threadId = $props.message.threadId))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconForumOutline, { size: 20 })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Go to thread')), 1)
                            ]),
                            _: 1
                          }),
                          ($options.isModeratorOrOwner)
                            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                key: "edit-thread",
                                "close-after-click": "",
                                onClick: _withModifiers($options.renameThread, ["stop"])
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_IconPencilOutline, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Edit thread details')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    ($options.canForwardMessage && !$options.isInNoteToSelf)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "forward-to-note",
                          "close-after-click": "",
                          onClick: $options.forwardToNote
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconNoteEditOutline, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Note to self')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    ($options.canForwardMessage)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "forward-message",
                          "close-after-click": "",
                          onClick: _withModifiers($options.openForwarder, ["stop"])
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconArrowRightTop, {
                              class: "bidirectional-icon",
                              size: 20
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Forward message')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    ($setup.messageActions.length > 0)
                      ? (_openBlock(), _createBlock(_component_NcActionSeparator, { key: 10 }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messageActions, (action) => {
                      return (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: action.label,
                        icon: action.icon,
                        "close-after-click": "",
                        onClick: $event => ($options.handleMessageAction(action))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(action.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["icon", "onClick"]))
                    }), 128)),
                    ($props.isTranslationAvailable && !$setup.isFileShareWithoutCaption)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: "translate-message",
                          "close-after-click": "",
                          onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$emit('showTranslateDialog', true)), ["stop"])),
                          onClose: _cache[3] || (_cache[3] = $event => (_ctx.$emit('showTranslateDialog', false)))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconTranslate, { size: 20 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Translate')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($setup.isDeleteable)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                          _createVNode(_component_NcActionSeparator),
                          _createVNode(_component_NcActionButton, {
                            key: "delete-message",
                            "close-after-click": "",
                            onClick: _withModifiers($options.handleDelete, ["stop"])
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconTrashCanOutline, { size: 20 })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Delete')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : ($setup.supportReminders && $data.submenu === 'reminder')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_NcActionButton, {
                        key: "action-back",
                        "aria-label": $options.t('spreed', 'Back'),
                        onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($data.submenu = null), ["stop"]))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconArrowLeft, { class: "bidirectional-icon" })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Back')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]),
                      ($data.currentReminder)
                        ? (_openBlock(), _createBlock(_component_NcActionButton, {
                            key: "remove-reminder",
                            "close-after-click": "",
                            onClick: _withModifiers($options.removeReminder, ["stop"])
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconCloseCircleOutline, { size: 20 })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.clearReminderLabel), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_NcActionSeparator),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reminderOptions, (option) => {
                        return (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: option.key,
                          "aria-label": option.ariaLabel,
                          "close-after-click": "",
                          onClick: _withModifiers($event => ($options.setReminder(option.timestamp)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["aria-label", "onClick"]))
                      }), 128)),
                      _createVNode(_component_NcActionSeparator),
                      _createVNode(_component_NcActionInput, {
                        modelValue: $options.customReminderDateTime,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($options.customReminderDateTime) = $event)),
                        type: "datetime-local",
                        "is-native-picker": "",
                        min: new Date()
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconCalendarClockOutline, { size: 20 })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "min"]),
                      _createVNode(_component_NcActionButton, {
                        key: "set-reminder",
                        "aria-label": $options.t('spreed', 'Set custom reminder'),
                        "close-after-click": "",
                        onClick: _cache[6] || (_cache[6] = _withModifiers($event => ($options.setReminder($data.customReminderTimestamp)), ["stop"]))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconCheck, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Set custom reminder')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"])
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["boundaries-element", "onOpen", "onClose"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_NcButton, {
            variant: "tertiary",
            "aria-label": $options.t('spreed', 'Close reactions menu'),
            onClick: $options.closeReactionsMenu
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconArrowLeft, {
                class: "bidirectional-icon",
                size: 20
              })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.frequentlyUsedEmojis, (emoji) => {
            return (_openBlock(), _createBlock(_component_NcButton, {
              key: emoji,
              variant: "tertiary",
              "aria-label": $options.t('spreed', 'React with {emoji}', { emoji }),
              onClick: $event => ($options.handleReactionClick(emoji))
            }, {
              icon: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(emoji), 1)
              ]),
              _: 2
            }, 1032, ["aria-label", "onClick"]))
          }), 128)),
          _createVNode(_component_NcEmojiPicker, {
            boundary: $options.boundariesElement,
            placement: "auto",
            onSelect: $options.handleReactionClick,
            onAfterShow: $options.onEmojiPickerOpen,
            onAfterHide: $options.onEmojiPickerClose
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NcButton, {
                variant: "tertiary",
                "aria-label": $options.t('spreed', 'React with another emoji')
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconPlus, { size: 20 })
                ]),
                _: 1
              }, 8, ["aria-label"])
            ]),
            _: 1
          }, 8, ["boundary", "onSelect", "onAfterShow", "onAfterHide"])
        ], 64))
  ])), [
    [_directive_click_outside, $options.handleClickOutside]
  ])
}